import { axiosWithAuth } from "helpers";

export const tidEquipmentDetailsService = {
	getTidEquipmentDetails,
	getTidEquipmentQADetails,
	tidEquipmentUpdateTerminal,
	tidEquipmentComplete,
	tidEquipmentQaComplete,
};

const API_URL = process.env.REACT_APP_API_URL;

function getTidEquipmentDetails(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/equipment_queue/${applicationId}/details`,
	};

	return axiosWithAuth(options);
}

function getTidEquipmentQADetails(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/equipment_queue/qa/${applicationId}/details`,
	};

	return axiosWithAuth(options);
}

function tidEquipmentUpdateTerminal({ merchantId, terminalId, terminal }) {
	const shippingFields = ["order_number", "tracking_number", "carrier"];

	const getPath = item => {
		if (shippingFields.includes(item)) {
			return `/shipping/${item}`;
		}
		if (item === "install_date") {
			return "/installation/install_at";
		}
		return `/${item}`;
	};

	const data = Object.keys(terminal).map(item => ({
		value: terminal[item],
		path: getPath(item),
		op: "replace",
	}));

	return axiosWithAuth({
		method: "PATCH",
		data,
		url: `${API_URL}/api/merchants/${merchantId}/terminal_solutions/${terminalId}`,
		headers: { "Content-Type": "application/json-patch+json" },
	});
}

function tidEquipmentComplete(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/${applicationId}/complete`,
	};

	return axiosWithAuth(options);
}

function tidEquipmentQaComplete(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/qa/${applicationId}/complete`,
	};

	return axiosWithAuth(options);
}
